import { createContext, FC, PropsWithChildren, useCallback, useEffect, useMemo, useState } from "react";
import { IProperty } from "../users-service-types";
import { userService } from "../../index";

export interface IPropertiesContext {
    properties: IProperty[],
    getProperty: (key: string) => string | undefined
}

export const propertiesContext = createContext<IPropertiesContext>({
    properties: [],
    getProperty: () => {
        return undefined
    }
});

interface IPropertiesProviderProps extends PropsWithChildren {
}

export const PropertiesProvider: FC<IPropertiesProviderProps> = ({ children }) => {
    const [properties, setProperties] = useState<IProperty[]>([])

    useEffect(() => {
        userService.loadProperties().then(res => {
            if (typeof res === "string") {
                try {
                    setProperties(JSON.parse(res));
                } catch (e) {
                    setProperties([]);
                }
            } else {
                setProperties(res);
            }
        })
    }, [])

    const getProperty = useCallback((key: string) => {
        const property = properties.find(p => p.attribute === key);
        return property ? property.value : undefined;
    }, [properties])

    return <propertiesContext.Provider value={{ properties, getProperty}}>{children}</propertiesContext.Provider>;
}
